module.exports = __webpack_public_path__ + "static/img/demo-header.139b531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-header.png
// module id = k+6V
// module chunks = 0